module.exports = __webpack_public_path__ + "img/rjcCertifiedMember.0f8c49e.webp";